{
  "mySystems": {
    "title": "Meine Systeme",
    "description": "Softwaresysteme, die du verantwortest und verwaltest.",
    "empty": "Du verantwortest keine Softwaresysteme in deiner Organisation."
  },
  "systemLandscape": {
    "title": "Systemlandschaft",
    "view": {
      "list": "Liste",
      "2d": "2D",
      "3d": "3D"
    },
    "kpi": {
      "systems": "Systeme",
      "systemsDesc": "Aktive Systeme gesamt",
      "connections": "Verbindungen",
      "connectionsDesc": "System-zu-System-Interaktionen",
      "avgConnections": "Ø Verbindungen",
      "avgConnectionsDesc": "Pro System",
      "isolated": "Isolierte Systeme",
      "isolatedDesc": "Systeme ohne Verbindungen",
      "mediaBreaks": "Medienbrüche",
      "mediaBreaksDesc": "Systemübergangs-Brüche"
    },
    "list": {
      "connections": "Verbindungen",
      "mediaBreaks": "Medienbrüche"
    },
    "tooltip": {
      "upstream": "Empfängt von",
      "downstream": "Sendet an",
      "interactionCount": "{{count}} Interaktionen"
    },
    "navInfo": "Linksklick: Drehen · Mausrad: Zoomen · Rechtsklick: Schwenken"
  },
  "shadowSystems": {
    "title": "Schatten-Systeme",
    "description": "Software, auf die sich Mitarbeitende in abgeschlossenen Prozessaufnahmen stützen, die aber nicht in den offiziellen Katalog aufgenommen wurde – deine Schatten-IT, sichtbar gemacht.",
    "search": "Schatten-Systeme suchen...",
    "empty": "Keine Schatten-Systeme – sämtliche in abgeschlossenen Aufnahmen referenzierte Software ist freigegeben.",
    "stats": {
      "shadowSystems": "Schatten-Systeme",
      "recordingsAffected": "Betroffene abgeschlossene Aufnahmen"
    },
    "columns": {
      "system": "System",
      "category": "Kategorie",
      "url": "Link",
      "openLink": "Externen Link öffnen",
      "occurrences": "Vorkommen",
      "suggestedBy": "Vorgeschlagen von",
      "submittedAt": "Vorgeschlagen am",
      "reviewedBy": "Abgelehnt von",
      "reviewedAt": "Abgelehnt am",
      "rejectionReason": "Ablehnungsgrund",
      "source": "Quelle"
    },
    "actions": {
      "resolve": "Auflösen",
      "resolved": "Schatten-System aufgelöst"
    },
    "resolveDialog": {
      "title": "Schatten-System auflösen",
      "description": "Beschreibung",
      "useExisting": "In bestehendes zusammenführen",
      "createNew": "Neues System anlegen",
      "targetSystem": "Zielsystem",
      "selectSystem": "System auswählen",
      "name": "Name",
      "systemOwner": "Systemverantwortlicher",
      "selectOwner": "Verantwortlichen auswählen",
      "category": "Kategorie",
      "url": "Link"
    }
  }
}
